import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountNotificationPreferences" })
export default class AccountNotificationPreferences extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public formData: any = { isNewsletterSubscription: false };
    public interests: any[] = [];
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        await this.getData();
        this.isLoading = false;
    }

    public async getData() {
        const result = (await Axios.post(this.routes.MyBeghelliProfile_GetNotificationData, null)).data;

        this.formData.isNewsletterSubscription = result.newsletterStatus === 'Active';
    }

    public async notificationUpdate() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        try {
            await Axios.post(this.routes.MyBeghelliProfile_NotificationUpdate, this.formData);

            await this.getData();
            this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.SuccessfullyUpdatedData"), type: "Success" });
        }
        catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }
};